export const DomParser = new DOMParser();
export const ribbonButtonsColumnName = "_talxis_gridRibbonButtons";
export const FRONTEND_VERSION = process.env.REACT_APP_BUILD_VERSION;
export const APPLICATION_RIBBON_ENTITY_NAME = '_talxis_application_ribbon';
export const BODY_BACKGROUND_COLOR = '#faf9f8';